import * as React from 'react';
import moment from 'moment';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';

interface IDateTimeViewProps {
    dateTime: LocalDateTime;
    format?: string;
}

const DateTimeView = (props: IDateTimeViewProps) => {
    if (!props.dateTime) {
        return null;
    }

    const selectedFormat = props.format ? props.format : 'L LT';
    const { originalDateTime, localDateTime } = props.dateTime;

    const tooltip = (
        <Tooltip id="tooltip">
            {Translate('date-time-view/orignal-timezone')}:{' '}
            {moment(originalDateTime).format(selectedFormat)}
        </Tooltip>
    );

    if (originalDateTime && localDateTime !== originalDateTime) {
        return (
            <span className="date-time-local nobreak">
                {moment(localDateTime).format(selectedFormat)}
                &nbsp;
                <OverlayTrigger overlay={tooltip} placement="top" delayShow={300} delayHide={150}>
                    <i className="material-icons md-18">language</i>
                </OverlayTrigger>
            </span>
        );
    } else {
        return (
            <span className="date-time-local nobreak">
                {moment(localDateTime).format(selectedFormat)}
            </span>
        );
    }
};

export default DateTimeView;

export class LocalDateTime {
    localDateTime: Date;
    originalDateTime?: Date;
}
